module.exports = "/_next/static/images/3c4a773209439ea55578299bcf947d9b-card-and-phone-3d-md@2x.jpg.webp";